import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { useTheme } from 'ThemeContext';
import { useCookies } from 'react-cookie';
import { AppSettingsContext } from 'AppSettingsContext';
import {
  Wrapper,
  Container,
  Box,
  Content,
  Text,
  Menu,
  Button,
  ButtonLink,
  ButtonIcon
} from './Cookies.style';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function Cookies({ text = '', slug }) {
  const [cookies, setCookie] = useCookies(['APP_COOKIES_POLICY']);
  const theme = useTheme();
  const [appSettings] = useContext(AppSettingsContext);

  return (
    <>
      {cookies && !cookies['APP_COOKIES_POLICY'] ? (
        <Wrapper theme={theme.cookies.wrapper}>
          <Container
            widerTheme={appSettings.theme === 6 ? String(true) : undefined}
            narrowerTheme={appSettings.theme === 4 ? String(true) : undefined}
          >
            <Box>
              <Content>
                <Text theme={theme.cookies.text}>{text}</Text>
              </Content>
              <Menu>
                <Button
                  theme={theme.button}
                  onClick={() => {
                    setCookie('APP_COOKIES_POLICY', true, {
                      path: '/',
                      maxAge: 60 * 60 * 24 * 30
                    });
                  }}
                >
                  <FormattedMessage id='COOKIES.ACCEPT' />
                </Button>
                {slug ? (
                  <ButtonLink
                    theme={theme.button}
                    smooth
                    to={slug && slug[0] === '/' ? slug : `/${slug}`}
                    invert={'true'}
                  >
                    <FormattedMessage id='COOKIES.MORE_INFORMATION' />
                    <ButtonIcon theme={theme.buttonIcon}>
                      <FontAwesomeIcon icon={theme.buttonIcon.faIcon} />
                    </ButtonIcon>
                  </ButtonLink>
                ) : (
                  ''
                )}
              </Menu>
            </Box>
          </Container>
        </Wrapper>
      ) : (
        ''
      )}
    </>
  );
}

export default Cookies;
